module.exports = __webpack_public_path__ + "img/84.non-sticky_carpet.e1d895d8.svg";